/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as TermeniRouteImport } from './routes/termeni'
import { Route as PublicLandingRouteImport } from './routes/public-landing'
import { Route as PentruBusinessRouteImport } from './routes/pentru-business'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as OffersPreviewRouteImport } from './routes/offers-preview'
import { Route as JoinRouteImport } from './routes/join'
import { Route as FondatorRouteImport } from './routes/fondator'
import { Route as ConfidentialitateRouteImport } from './routes/confidentialitate'
import { Route as IndexRouteImport } from './routes/index'
import { Route as NoutatiIndexRouteImport } from './routes/noutati.index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as PayIntentIdRouteImport } from './routes/pay.$intentId'
import { Route as NoutatiSlugRouteImport } from './routes/noutati.$slug'
import { Route as MSlugRouteImport } from './routes/m.$slug'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AppRewardsRouteImport } from './routes/app/rewards'
import { Route as AppReceiptsRouteImport } from './routes/app/receipts'
import { Route as AppProfileRouteImport } from './routes/app/profile'
import { Route as AppMembershipRouteImport } from './routes/app/membership'
import { Route as AppMapRouteImport } from './routes/app/map'
import { Route as AppInvitesRouteImport } from './routes/app/invites'
import { Route as AppHistoryRouteImport } from './routes/app/history'
import { Route as AppFavoritesRouteImport } from './routes/app/favorites'
import { Route as AppOffersIndexRouteImport } from './routes/app/offers/index'
import { Route as TestFakeBankAttemptIdRouteImport } from './routes/test.fake-bank.$attemptId'
import { Route as AppReceiptsReceiptIdRouteImport } from './routes/app/receipts.$receiptId'
import { Route as AppOffersOfferIdRouteImport } from './routes/app/offers/$offerId'

const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const TermeniRoute = TermeniRouteImport.update({
  id: '/termeni',
  path: '/termeni',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLandingRoute = PublicLandingRouteImport.update({
  id: '/public-landing',
  path: '/public-landing',
  getParentRoute: () => rootRouteImport,
} as any)
const PentruBusinessRoute = PentruBusinessRouteImport.update({
  id: '/pentru-business',
  path: '/pentru-business',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnersRoute = PartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => rootRouteImport,
} as any)
const OffersPreviewRoute = OffersPreviewRouteImport.update({
  id: '/offers-preview',
  path: '/offers-preview',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinRoute = JoinRouteImport.update({
  id: '/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const FondatorRoute = FondatorRouteImport.update({
  id: '/fondator',
  path: '/fondator',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfidentialitateRoute = ConfidentialitateRouteImport.update({
  id: '/confidentialitate',
  path: '/confidentialitate',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const NoutatiIndexRoute = NoutatiIndexRouteImport.update({
  id: '/noutati/',
  path: '/noutati/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => rootRouteImport,
} as any)
const PayIntentIdRoute = PayIntentIdRouteImport.update({
  id: '/pay/$intentId',
  path: '/pay/$intentId',
  getParentRoute: () => rootRouteImport,
} as any)
const NoutatiSlugRoute = NoutatiSlugRouteImport.update({
  id: '/noutati/$slug',
  path: '/noutati/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const MSlugRoute = MSlugRouteImport.update({
  id: '/m/$slug',
  path: '/m/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/auth/verify',
  path: '/auth/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/auth/register',
  path: '/auth/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/auth/login',
  path: '/auth/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRewardsRoute = AppRewardsRouteImport.update({
  id: '/app/rewards',
  path: '/app/rewards',
  getParentRoute: () => rootRouteImport,
} as any)
const AppReceiptsRoute = AppReceiptsRouteImport.update({
  id: '/app/receipts',
  path: '/app/receipts',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/app/profile',
  path: '/app/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMembershipRoute = AppMembershipRouteImport.update({
  id: '/app/membership',
  path: '/app/membership',
  getParentRoute: () => rootRouteImport,
} as any)
const AppMapRoute = AppMapRouteImport.update({
  id: '/app/map',
  path: '/app/map',
  getParentRoute: () => rootRouteImport,
} as any)
const AppInvitesRoute = AppInvitesRouteImport.update({
  id: '/app/invites',
  path: '/app/invites',
  getParentRoute: () => rootRouteImport,
} as any)
const AppHistoryRoute = AppHistoryRouteImport.update({
  id: '/app/history',
  path: '/app/history',
  getParentRoute: () => rootRouteImport,
} as any)
const AppFavoritesRoute = AppFavoritesRouteImport.update({
  id: '/app/favorites',
  path: '/app/favorites',
  getParentRoute: () => rootRouteImport,
} as any)
const AppOffersIndexRoute = AppOffersIndexRouteImport.update({
  id: '/app/offers/',
  path: '/app/offers/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestFakeBankAttemptIdRoute = TestFakeBankAttemptIdRouteImport.update({
  id: '/test/fake-bank/$attemptId',
  path: '/test/fake-bank/$attemptId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppReceiptsReceiptIdRoute = AppReceiptsReceiptIdRouteImport.update({
  id: '/$receiptId',
  path: '/$receiptId',
  getParentRoute: () => AppReceiptsRoute,
} as any)
const AppOffersOfferIdRoute = AppOffersOfferIdRouteImport.update({
  id: '/app/offers/$offerId',
  path: '/app/offers/$offerId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/confidentialitate': typeof ConfidentialitateRoute
  '/fondator': typeof FondatorRoute
  '/join': typeof JoinRoute
  '/offers-preview': typeof OffersPreviewRoute
  '/partners': typeof PartnersRoute
  '/pentru-business': typeof PentruBusinessRoute
  '/public-landing': typeof PublicLandingRoute
  '/termeni': typeof TermeniRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/app/favorites': typeof AppFavoritesRoute
  '/app/history': typeof AppHistoryRoute
  '/app/invites': typeof AppInvitesRoute
  '/app/map': typeof AppMapRoute
  '/app/membership': typeof AppMembershipRoute
  '/app/profile': typeof AppProfileRoute
  '/app/receipts': typeof AppReceiptsRouteWithChildren
  '/app/rewards': typeof AppRewardsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/m/$slug': typeof MSlugRoute
  '/noutati/$slug': typeof NoutatiSlugRoute
  '/pay/$intentId': typeof PayIntentIdRoute
  '/app': typeof AppIndexRoute
  '/noutati': typeof NoutatiIndexRoute
  '/app/offers/$offerId': typeof AppOffersOfferIdRoute
  '/app/receipts/$receiptId': typeof AppReceiptsReceiptIdRoute
  '/test/fake-bank/$attemptId': typeof TestFakeBankAttemptIdRoute
  '/app/offers': typeof AppOffersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/confidentialitate': typeof ConfidentialitateRoute
  '/fondator': typeof FondatorRoute
  '/join': typeof JoinRoute
  '/offers-preview': typeof OffersPreviewRoute
  '/partners': typeof PartnersRoute
  '/pentru-business': typeof PentruBusinessRoute
  '/public-landing': typeof PublicLandingRoute
  '/termeni': typeof TermeniRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/app/favorites': typeof AppFavoritesRoute
  '/app/history': typeof AppHistoryRoute
  '/app/invites': typeof AppInvitesRoute
  '/app/map': typeof AppMapRoute
  '/app/membership': typeof AppMembershipRoute
  '/app/profile': typeof AppProfileRoute
  '/app/receipts': typeof AppReceiptsRouteWithChildren
  '/app/rewards': typeof AppRewardsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/m/$slug': typeof MSlugRoute
  '/noutati/$slug': typeof NoutatiSlugRoute
  '/pay/$intentId': typeof PayIntentIdRoute
  '/app': typeof AppIndexRoute
  '/noutati': typeof NoutatiIndexRoute
  '/app/offers/$offerId': typeof AppOffersOfferIdRoute
  '/app/receipts/$receiptId': typeof AppReceiptsReceiptIdRoute
  '/test/fake-bank/$attemptId': typeof TestFakeBankAttemptIdRoute
  '/app/offers': typeof AppOffersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/confidentialitate': typeof ConfidentialitateRoute
  '/fondator': typeof FondatorRoute
  '/join': typeof JoinRoute
  '/offers-preview': typeof OffersPreviewRoute
  '/partners': typeof PartnersRoute
  '/pentru-business': typeof PentruBusinessRoute
  '/public-landing': typeof PublicLandingRoute
  '/termeni': typeof TermeniRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/app/favorites': typeof AppFavoritesRoute
  '/app/history': typeof AppHistoryRoute
  '/app/invites': typeof AppInvitesRoute
  '/app/map': typeof AppMapRoute
  '/app/membership': typeof AppMembershipRoute
  '/app/profile': typeof AppProfileRoute
  '/app/receipts': typeof AppReceiptsRouteWithChildren
  '/app/rewards': typeof AppRewardsRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/m/$slug': typeof MSlugRoute
  '/noutati/$slug': typeof NoutatiSlugRoute
  '/pay/$intentId': typeof PayIntentIdRoute
  '/app/': typeof AppIndexRoute
  '/noutati/': typeof NoutatiIndexRoute
  '/app/offers/$offerId': typeof AppOffersOfferIdRoute
  '/app/receipts/$receiptId': typeof AppReceiptsReceiptIdRoute
  '/test/fake-bank/$attemptId': typeof TestFakeBankAttemptIdRoute
  '/app/offers/': typeof AppOffersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/confidentialitate'
    | '/fondator'
    | '/join'
    | '/offers-preview'
    | '/partners'
    | '/pentru-business'
    | '/public-landing'
    | '/termeni'
    | '/unsubscribe'
    | '/app/favorites'
    | '/app/history'
    | '/app/invites'
    | '/app/map'
    | '/app/membership'
    | '/app/profile'
    | '/app/receipts'
    | '/app/rewards'
    | '/auth/login'
    | '/auth/register'
    | '/auth/verify'
    | '/m/$slug'
    | '/noutati/$slug'
    | '/pay/$intentId'
    | '/app'
    | '/noutati'
    | '/app/offers/$offerId'
    | '/app/receipts/$receiptId'
    | '/test/fake-bank/$attemptId'
    | '/app/offers'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/confidentialitate'
    | '/fondator'
    | '/join'
    | '/offers-preview'
    | '/partners'
    | '/pentru-business'
    | '/public-landing'
    | '/termeni'
    | '/unsubscribe'
    | '/app/favorites'
    | '/app/history'
    | '/app/invites'
    | '/app/map'
    | '/app/membership'
    | '/app/profile'
    | '/app/receipts'
    | '/app/rewards'
    | '/auth/login'
    | '/auth/register'
    | '/auth/verify'
    | '/m/$slug'
    | '/noutati/$slug'
    | '/pay/$intentId'
    | '/app'
    | '/noutati'
    | '/app/offers/$offerId'
    | '/app/receipts/$receiptId'
    | '/test/fake-bank/$attemptId'
    | '/app/offers'
  id:
    | '__root__'
    | '/'
    | '/confidentialitate'
    | '/fondator'
    | '/join'
    | '/offers-preview'
    | '/partners'
    | '/pentru-business'
    | '/public-landing'
    | '/termeni'
    | '/unsubscribe'
    | '/app/favorites'
    | '/app/history'
    | '/app/invites'
    | '/app/map'
    | '/app/membership'
    | '/app/profile'
    | '/app/receipts'
    | '/app/rewards'
    | '/auth/login'
    | '/auth/register'
    | '/auth/verify'
    | '/m/$slug'
    | '/noutati/$slug'
    | '/pay/$intentId'
    | '/app/'
    | '/noutati/'
    | '/app/offers/$offerId'
    | '/app/receipts/$receiptId'
    | '/test/fake-bank/$attemptId'
    | '/app/offers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConfidentialitateRoute: typeof ConfidentialitateRoute
  FondatorRoute: typeof FondatorRoute
  JoinRoute: typeof JoinRoute
  OffersPreviewRoute: typeof OffersPreviewRoute
  PartnersRoute: typeof PartnersRoute
  PentruBusinessRoute: typeof PentruBusinessRoute
  PublicLandingRoute: typeof PublicLandingRoute
  TermeniRoute: typeof TermeniRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  AppFavoritesRoute: typeof AppFavoritesRoute
  AppHistoryRoute: typeof AppHistoryRoute
  AppInvitesRoute: typeof AppInvitesRoute
  AppMapRoute: typeof AppMapRoute
  AppMembershipRoute: typeof AppMembershipRoute
  AppProfileRoute: typeof AppProfileRoute
  AppReceiptsRoute: typeof AppReceiptsRouteWithChildren
  AppRewardsRoute: typeof AppRewardsRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  MSlugRoute: typeof MSlugRoute
  NoutatiSlugRoute: typeof NoutatiSlugRoute
  PayIntentIdRoute: typeof PayIntentIdRoute
  AppIndexRoute: typeof AppIndexRoute
  NoutatiIndexRoute: typeof NoutatiIndexRoute
  AppOffersOfferIdRoute: typeof AppOffersOfferIdRoute
  TestFakeBankAttemptIdRoute: typeof TestFakeBankAttemptIdRoute
  AppOffersIndexRoute: typeof AppOffersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/termeni': {
      id: '/termeni'
      path: '/termeni'
      fullPath: '/termeni'
      preLoaderRoute: typeof TermeniRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/public-landing': {
      id: '/public-landing'
      path: '/public-landing'
      fullPath: '/public-landing'
      preLoaderRoute: typeof PublicLandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pentru-business': {
      id: '/pentru-business'
      path: '/pentru-business'
      fullPath: '/pentru-business'
      preLoaderRoute: typeof PentruBusinessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partners': {
      id: '/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof PartnersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/offers-preview': {
      id: '/offers-preview'
      path: '/offers-preview'
      fullPath: '/offers-preview'
      preLoaderRoute: typeof OffersPreviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join': {
      id: '/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof JoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fondator': {
      id: '/fondator'
      path: '/fondator'
      fullPath: '/fondator'
      preLoaderRoute: typeof FondatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confidentialitate': {
      id: '/confidentialitate'
      path: '/confidentialitate'
      fullPath: '/confidentialitate'
      preLoaderRoute: typeof ConfidentialitateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/noutati/': {
      id: '/noutati/'
      path: '/noutati'
      fullPath: '/noutati'
      preLoaderRoute: typeof NoutatiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pay/$intentId': {
      id: '/pay/$intentId'
      path: '/pay/$intentId'
      fullPath: '/pay/$intentId'
      preLoaderRoute: typeof PayIntentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/noutati/$slug': {
      id: '/noutati/$slug'
      path: '/noutati/$slug'
      fullPath: '/noutati/$slug'
      preLoaderRoute: typeof NoutatiSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/$slug': {
      id: '/m/$slug'
      path: '/m/$slug'
      fullPath: '/m/$slug'
      preLoaderRoute: typeof MSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/auth/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/auth/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/auth/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/rewards': {
      id: '/app/rewards'
      path: '/app/rewards'
      fullPath: '/app/rewards'
      preLoaderRoute: typeof AppRewardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/receipts': {
      id: '/app/receipts'
      path: '/app/receipts'
      fullPath: '/app/receipts'
      preLoaderRoute: typeof AppReceiptsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/profile': {
      id: '/app/profile'
      path: '/app/profile'
      fullPath: '/app/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/membership': {
      id: '/app/membership'
      path: '/app/membership'
      fullPath: '/app/membership'
      preLoaderRoute: typeof AppMembershipRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/map': {
      id: '/app/map'
      path: '/app/map'
      fullPath: '/app/map'
      preLoaderRoute: typeof AppMapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/invites': {
      id: '/app/invites'
      path: '/app/invites'
      fullPath: '/app/invites'
      preLoaderRoute: typeof AppInvitesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/history': {
      id: '/app/history'
      path: '/app/history'
      fullPath: '/app/history'
      preLoaderRoute: typeof AppHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/favorites': {
      id: '/app/favorites'
      path: '/app/favorites'
      fullPath: '/app/favorites'
      preLoaderRoute: typeof AppFavoritesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/offers/': {
      id: '/app/offers/'
      path: '/app/offers'
      fullPath: '/app/offers'
      preLoaderRoute: typeof AppOffersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/fake-bank/$attemptId': {
      id: '/test/fake-bank/$attemptId'
      path: '/test/fake-bank/$attemptId'
      fullPath: '/test/fake-bank/$attemptId'
      preLoaderRoute: typeof TestFakeBankAttemptIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/receipts/$receiptId': {
      id: '/app/receipts/$receiptId'
      path: '/$receiptId'
      fullPath: '/app/receipts/$receiptId'
      preLoaderRoute: typeof AppReceiptsReceiptIdRouteImport
      parentRoute: typeof AppReceiptsRoute
    }
    '/app/offers/$offerId': {
      id: '/app/offers/$offerId'
      path: '/app/offers/$offerId'
      fullPath: '/app/offers/$offerId'
      preLoaderRoute: typeof AppOffersOfferIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AppReceiptsRouteChildren {
  AppReceiptsReceiptIdRoute: typeof AppReceiptsReceiptIdRoute
}

const AppReceiptsRouteChildren: AppReceiptsRouteChildren = {
  AppReceiptsReceiptIdRoute: AppReceiptsReceiptIdRoute,
}

const AppReceiptsRouteWithChildren = AppReceiptsRoute._addFileChildren(
  AppReceiptsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConfidentialitateRoute: ConfidentialitateRoute,
  FondatorRoute: FondatorRoute,
  JoinRoute: JoinRoute,
  OffersPreviewRoute: OffersPreviewRoute,
  PartnersRoute: PartnersRoute,
  PentruBusinessRoute: PentruBusinessRoute,
  PublicLandingRoute: PublicLandingRoute,
  TermeniRoute: TermeniRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  AppFavoritesRoute: AppFavoritesRoute,
  AppHistoryRoute: AppHistoryRoute,
  AppInvitesRoute: AppInvitesRoute,
  AppMapRoute: AppMapRoute,
  AppMembershipRoute: AppMembershipRoute,
  AppProfileRoute: AppProfileRoute,
  AppReceiptsRoute: AppReceiptsRouteWithChildren,
  AppRewardsRoute: AppRewardsRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  MSlugRoute: MSlugRoute,
  NoutatiSlugRoute: NoutatiSlugRoute,
  PayIntentIdRoute: PayIntentIdRoute,
  AppIndexRoute: AppIndexRoute,
  NoutatiIndexRoute: NoutatiIndexRoute,
  AppOffersOfferIdRoute: AppOffersOfferIdRoute,
  TestFakeBankAttemptIdRoute: TestFakeBankAttemptIdRoute,
  AppOffersIndexRoute: AppOffersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
